import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import { DocusignTemplateFormContent } from './DocusignTemplateFormContent'
import { docusignTemplateFormValidator } from './DocusignTemplateForm.validator'
import type { DocusignTemplateFormValues } from './DocusignTemplateForm.interface'

interface Props {
  formId: string
  onSubmit(values: DocusignTemplateFormValues): void
}

const DocusignTemplateFormComponent = ({ formId, onSubmit }: Props) => {
  // Create-only, so the initial values are constant — there is no row to seed from. The backend
  // exposes no update route (design §2.4), so this form has no edit mode.
  const initialValues = useMemo<DocusignTemplateFormValues>(() => {
    return {
      title: '',
      docusignId: '',
      description: '',
    }
  }, [])

  const handleSubmit = useCallback(
    (values: DocusignTemplateFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<DocusignTemplateFormValues>
      initialValues={initialValues}
      validationSchema={docusignTemplateFormValidator}
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <DocusignTemplateFormContent />
      </Form>
    </Formik>
  )
}

export const DocusignTemplateForm = memo(DocusignTemplateFormComponent)
